module.exports = __webpack_public_path__ + "static/media/vu.aacc4358.png";